function source_reference_prep() {
    let cta_btn = '[href*=enquiry]',
        page_current = window.location.pathname;

    document.querySelectorAll(cta_btn).forEach( function(e) {
        let href_current = e.getAttribute('href').split('?')[0];
        // console.log(href_current);
        e.setAttribute('href', href_current + '?source=' + page_current);
    });
}

source_reference_prep();